import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const limePlugin = createPlugin({
  id: 'lime',
  routes: {
    root: rootRouteRef,
  },
});

export const LimePage = limePlugin.provide(
  createRoutableExtension({
    name: 'LimePage',
    component: () =>
      import('./components/LimeTabsComponent').then(m => m.LimeTabsComponent),
    mountPoint: rootRouteRef,
  }),
);
